import classNames from "classnames";

export default function Container({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={classNames(
        "mx-auto max-w-240 p-6 lg:max-w-440",
        className,
      )}
    >
      {children}
    </div>
  );
}
